/**
 * Shared coalescing keys for the dashboard data slices.
 *
 * Both the Zustand store fetch actions (visitStore, sittingStore) and the
 * dashboard hydrator reference these SAME keys so that, on dashboard mount,
 * each widget's fetch piggybacks on the single `dashboard-summary` request
 * instead of firing its own. See utils/coalesce.js.
 */
export const DATA_KEYS = {
  daily: 'visit:daily',
  doctors: 'visit:doctors',
  stats: 'visit:stats',
  myQueue: 'sitting:myQueue',
  delegated: 'sitting:delegated',
  actionPending: 'sitting:actionPending',
  // Suffixed with the visit id at the call site (per-visit coalescing).
  forVisit: 'sitting:forVisit',
};
